module.exports = __webpack_public_path__ + "static/desktop-stepper-silver-icon-551f2855e69a4c4d53201ea3b76aab2a.svg";